module.exports = __webpack_public_path__ + "img/edison-infiniti.8d678110.png";